// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__b1u6k","actionsCol":"EnrolledClinics_actionsCol__3fazE"};